module.exports = __webpack_public_path__ + "img/electrical.a6531a7a.jpg";